qw-extra {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
}

qw-extra .qw-extra__card-wrapper {
  display: flex;
  justify-content: flex-start;
  flex-flow: row wrap;
  width: 100%;
}
qw-extra .qw-extra__card-wrapper--room-extras {
  flex-flow: column;
}

qw-extra .qw-extra__card-content {
  display: flex;
  justify-content: flex-start;
  flex-flow: row wrap;
  width: 100%;
}

qw-extra qw-extra-card {
  width: 32%;
  margin-right: 1%;
}

qw-extra .qw-button {
  width: 30%;
}
